@if (compact) {
  <mat-expansion-panel class="activity-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>speaker_notes</mat-icon>
        <span>Notes</span>
        <span class="activity-count">{{ notes?.length || 0 }}</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="activity-note-toolbar">
      <button mat-button type="button" (click)="createNote()">
        <mat-icon>add</mat-icon>Add note
      </button>
    </div>
    <div class="activity-list">
      @for (note of notes || []; track note) {
        <div class="activity-record">
          <div class="activity-record-heading">
            <div class="activity-record-name">{{ note.basicName }}</div>
            <div class="activity-record-actions">
              <button mat-icon-button type="button" (click)="note.isExpanded = !note.isExpanded"
                [attr.aria-expanded]="!!note.isExpanded" aria-label="Toggle note details" matTooltip="Show note details">
                <mat-icon>{{ note.isExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
            </div>
          </div>
          <p class="activity-record-secondary">{{ note.createdAt | date: 'mediumDate' }}</p>
          @if (note.basicDescription) { <p class="activity-record-secondary">{{ note.basicDescription }}</p> }
          <p class="activity-note-text">{{ note.text }}</p>
          @if (note.isExpanded) {
            <div class="activity-record-details">
              <p>Username: {{ note.username }}</p>
              <p>Created: {{ note.createdAt | date: 'short' }}</p>
              <p>Updated: {{ note.updatedAt | date: 'short' }}</p>
              <p>Issue value: {{ note.issueValue }}</p>
              <p>Severity: {{ note.severity }}</p>
            </div>
          }
        </div>
      } @empty {
        <p class="activity-empty">No notes yet. Add a note to keep track of this account.</p>
      }
    </div>
  </mat-expansion-panel>
} @else {
@if (notes) {
  <div class="col-12 col-sm-12 col-md-12" [ngClass]="{'col-lg-6 col-xxl-6': !isLong }"
    style="float: left; margin-bottom: 10px;">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title class="superbold" style="align-items: center; font-size: 1.75rem;">
            <mat-icon>speaker_notes</mat-icon>
            Notes ({{notes.length}})
          </mat-panel-title>
        </mat-expansion-panel-header>
        <!-- <h3 class="text label-header-text">
        <mat-icon>speaker_notes</mat-icon>
        Notes ({{notes.length}})
      </h3> -->
      <button (click)="createNote()" style="float: right;" mat-icon-button><mat-icon>add</mat-icon></button>
      @if (notes.length > 0) {
        <div style="max-height: 50vh; overflow: auto">
          @for (note of notes; track note; let i = $index) {
            <div class="text label-text item-card">
              <mat-card appearance="outlined" (click)="clickEvent(note)">
                <p class="text label-text" style="margin: 0px; float:left">
                  {{i + 1}}. {{ note.basicName }}
                </p>
                <br>
                  <p class="text small-text" style="margin: 0px; float: right;">
                    <b>{{ note.createdAt | date: 'short'}}</b>
                  </p>
                  <p class="text small-text" style="margin: 0px">
                    {{ note.basicDescription }}
                  </p>
                  <!-- <br> -->
                        <p class="text small-text" style="margin: 0px;
                     text-align: center; 
                     padding: 10px; 
                     padding-top: 20px;
                     max-height: 100px; 
                     overflow-y: auto;">
                    {{ note.text }}
                  </p>
                  <br>
                    @if (note.isExpanded) {
                      <div>
                        <hr />
                        <p class="text small-text" style="margin: 0px; float: left;">
                          Username: {{ note.username }}
                        </p>
                        <p class="text small-text" style="margin: 0px; float: right;">
                          Created: {{ note.createdAt | date: 'short'}}
                        </p>
                        <br>
                          <p class="text small-text" style="margin: 0px; float: left;">
                            Issue Value: {{ note.issueValue }}
                          </p>
                          <p class="text small-text" style="margin: 0px; float: right;">
                            Updated: {{ note.updatedAt | date: 'short'}}
                          </p>
                          <br>
                            <p class="text small-text" style="margin: 0px;">
                              Severity: {{ note.severity }}
                            </p>
                          </div>
                        }
                        <button href="javascript:void()" color="warn" style="position: absolute; right: 0px; top: 0px;"
                          mat-icon-button (click)="note.isExpanded = !note.isExpanded">
                          @if (!note.isExpanded) {
                            <mat-icon class="mat-18">expand_more</mat-icon>
                          }
                          @if (note.isExpanded) {
                            <mat-icon class="mat-18">expand_less</mat-icon>
                          }
                        </button>
                      </mat-card>
                    </div>
                  }
                </div>
              } @else {
                <p class="text h3" style="padding-top: 12px;">
                  No notes have been found for this entity.
                </p>
              }
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      } @else {
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-4" style="float: left">
          <mat-card appearance="outlined">
            <h3 class="text label-header-text">
              Click to add new note
            </h3>
            <button (click)="createNote()" style="float: right;" mat-icon-button><mat-icon>add</mat-icon></button>
            <hr />
            <p class="text small-text" style="margin: 0px;">
              No data found.
            </p>
          </mat-card>
        </div>
      }

}
